import type { RefObject } from 'react';
import type { PopulatedMenu } from 'root/apiTypes';
import { SECTION_ID_PREFIX } from 'root/consts';

export const getNavigationOffset = (navigationContainer: HTMLDivElement | null): number => {
  if (!navigationContainer) {
    return 0;
  }

  const navigationHeight = navigationContainer.getBoundingClientRect().height;
  const navigationComputedStyle = window.getComputedStyle(navigationContainer);
  const navigationTopOffset = parseInt(navigationComputedStyle.top, 10) || 0;

  return navigationHeight + navigationTopOffset;
};

export const findSectionIndex = (sections: PopulatedMenu['sections'], sectionId: string): number => {
  return sections?.findIndex((section) => section.id === sectionId) ?? -1;
};

export const getScrollTop = (targetElementRef: RefObject<HTMLDivElement> | undefined, navigationOffset: number) => {
  const targetRect = targetElementRef?.current?.getBoundingClientRect();
  if (targetRect) {
    const targetTop = targetRect.top + window.scrollY;
    const finalScrollTop = targetTop - navigationOffset;
    const clampedScrollTop = Math.max(0, finalScrollTop);
    return clampedScrollTop;
  }
};
export const getSectionIdFromSection = (sectionId: string) => sectionId.replace(SECTION_ID_PREFIX, '');
export const customHeaderTestId1 = '[data-testid="section-container"]';
export const customHeaderId2 = '[id="SITE_HEADER"]';
export const sectionNavigationTopOffset = '--sectionNavigationTopOffset';
